(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("xmlentities"));
	else if(typeof define === 'function' && define.amd)
		define(["xmlentities"], factory);
	else if(typeof exports === 'object')
		exports["cmdControlClientLib"] = factory(require("xmlentities"));
	else
		root["cmdControlClientLib"] = factory(root["xmlentities"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__1994__) {
return 